import React from 'react';
import CMSPage from '../../components/CMSPage/CMSPage';

const WhoWeArePage = () => {
  return <CMSPage pageType="who-we-are" />;
};

export default WhoWeArePage;
